import { render, staticRenderFns } from "./vacation-add-or-update.vue?vue&type=template&id=5642bad2&scoped=true&"
import script from "./vacation-add-or-update.vue?vue&type=script&lang=js&"
export * from "./vacation-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./vacation-add-or-update.vue?vue&type=style&index=0&id=5642bad2&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5642bad2",
  null
  
)

export default component.exports